module.exports = __webpack_public_path__ + "img/solution8.7054bc9b.png";